import { Component, HostBinding, Input } from '@angular/core';
import { CurrentUserService } from '@services/current-user.service';
import { of } from 'rxjs';
import { delay } from 'rxjs/operators';

@Component({
  selector: 'vnm-app-distractor',
  templateUrl: './app-distractor.component.html',
  styleUrls: ['./app-distractor.component.scss']
})
export class AppDistractorComponent {
  @HostBinding('class.app-distractor') appDistractor = true;
  @Input() label = 'app.authenticating';
  authTimeout$ = of(true).pipe(delay(10000));

  constructor(private userService: CurrentUserService) {}

  onEscapeAuth(event: Event) {
    event.preventDefault();
    this.userService.clearImpersonation().subscribe((url) => {
      let redirectUrl: string;

      if (url) {
        redirectUrl = url.toString();
      } else {
        redirectUrl = '/';
      }
      window.location.replace(redirectUrl);
    });
  }
}
